// reducers/userReducer.js
import { FETCH_USERS_REQUEST, FETCH_USERS_SUCCESS, FETCH_USERS_FAIL, UPDATE_USER_PERMISSION_REQUEST, UPDATE_USER_PERMISSION_SUCCESS, UPDATE_USER_PERMISSION_FAIL } from '../constants/userConstants';

const initialState = {
  users: [],
  loading: false,
  error: null,
};

export const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_USERS_REQUEST:
    case UPDATE_USER_PERMISSION_REQUEST:
      return { ...state, loading: true };
    case FETCH_USERS_SUCCESS:
      return { ...state, loading: false, users: action.payload };
    case UPDATE_USER_PERMISSION_SUCCESS:
      return {
        ...state,
        loading: false,
        users: state.users.map((user) =>
          user._id === action.payload._id ? action.payload : user
        ),
      };
    case FETCH_USERS_FAIL:
    case UPDATE_USER_PERMISSION_FAIL:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};